export {
  getAuthor,
  getCreator,
  getDefaultUrl,
  getKeywords,
  getLocale,
  getPreviewImage,
  getSiteName,
  getType,
} from '@/libs/runtime-config/runtime-config';
